import { Arrange, Icon, Text, Tooltip } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';

import { useShareWithMeFTUXTooltipState } from 'utilities/localStorage/ftux';

import DroppableItem from './droppableItem';

import FTUXTooltip from 'components/ftux-tooltip';

import styles from './styles.module.less';

const pathName = window.location.pathname;
const isCurrentPath = path => {
  return new RegExp(`^${path}`).test(pathName);
};

const MenuItem = ({ item, navBarIsCollapsed, isActive, className = null }) => {
  const [, dismissTooltip] = useShareWithMeFTUXTooltipState();

  const content = (
    <a
      href={item.path}
      onClick={item.onClick}
      className={classNames(styles.itemLink, className)}
      tabIndex={0}
    >
      <Arrange justifyContent="space-between" width="100%">
        <Arrange gap="small">
          {item.icon && (
            <div className={styles.itemIconSection}>
              <Icon color="currentColor" icon={<item.icon />} />
            </div>
          )}

          <Text fontWeight="bold">{item.view || item.label}</Text>
        </Arrange>
        {item.count > 0 && !navBarIsCollapsed && (
          <div
            className={classNames(
              styles.count,
              'bgc:record c:white weight:medium'
            )}
          >
            {item.count >= 99 ? '99+' : item.count}
          </div>
        )}
      </Arrange>
    </a>
  );

  return item.shouldShowFTUXTooltip && !isActive ? (
    <>
      <FTUXTooltip
        variant={
          navBarIsCollapsed
            ? 'tooltipOnCollapsedNavBar'
            : 'tooltipOnExpandedOldNavBar'
        }
        title="New sharing features!"
        subtitle={
          <>
            No more losing Looms! Keep track of videos you have been added to in
            your <b>Shared with me space.</b>
          </>
        }
        dismissTooltip={dismissTooltip}
      />
      {content}
    </>
  ) : (
    <Tooltip
      isInline={false}
      content={navBarIsCollapsed && (item.view || item.label)}
      placement="rightCenter"
    >
      {content}
    </Tooltip>
  );
};

const MenuListItem = ({
  item,
  withDrop,
  tooltip,
  navBarIsCollapsed,
  isNested,
  hasExpandedItems,
}) => {
  const isActive = isCurrentPath(item.path);

  return (
    <li
      className={classNames(item.className, styles.menuItem, {
        [styles.active]: isActive,
        [styles.menuItemNested]: isNested,
        [styles.hasExpandedItems]: hasExpandedItems,
        [styles.hasFTUXTooltip]: item.shouldShowFTUXTooltip,
      })}
    >
      {withDrop ? (
        <DroppableItem
          navBarIsCollapsed={navBarIsCollapsed}
          item={item}
          isActive={isActive}
        />
      ) : (
        <MenuItem
          navBarIsCollapsed={navBarIsCollapsed}
          item={item}
          isActive={isActive}
        />
      )}

      {tooltip ? tooltip : null}
    </li>
  );
};

export default MenuListItem;
